import { useRef2 } from '@ai-indeed/hooks';
import { createReader } from '@ai-indeed/reader';

export const useReader = (setup: Parameters<typeof createReader>[0]) =>
  useRef2(() => createReader(setup)).current;
